import PWMLogIcon from '@mui/icons-material/ExitToAppOutlined';
import PWMSOPIcon from '@mui/icons-material/MenuBookOutlined';
import PWMAltLogIcon from '@mui/icons-material/InputOutlined';
import PWMEditIcon from '@mui/icons-material/EditOutlined';
import PWMViewIcon from '@mui/icons-material/OpenInNewOutlined';
import PWMVerifiedIcon from '@mui/icons-material/VerifiedUser';
import PWMMenuIcon from '@mui/icons-material/Menu';
import PWMWarningIcon from '@mui/icons-material/Warning';
import PWMInActiveIcon from '@mui/icons-material/EventBusy';
import PWMDownloadIcon from "@untitled-ui/icons-react/build/esm/Download03";
import PWMPdfIcon from '@mui/icons-material/PictureAsPdf';
import PWMRefreshIcon from '@mui/icons-material/Refresh';
import PWMCheckedIcon from '@mui/icons-material/Check';
import PWMXIcon from '@mui/icons-material/HighlightOffTwoTone';
import PWMUncheckedIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import PWMArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import PWMArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import PWMArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import PWMArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import PWMFolderIcon from '@mui/icons-material/FolderOutlined';
import PWMFileIcon from '@mui/icons-material/AttachFileOutlined';
import PWMHelpIcon from '@mui/icons-material/LiveHelpTwoTone';
import PWMDeleteIcon from '@mui/icons-material/DeleteOutlined';
import PWMListIcon from '@mui/icons-material/FormatListBulletedOutlined';
import PWMSearchIcon from '@mui/icons-material/SearchOutlined';
import PwmPlusIcon from '@untitled-ui/icons-react/build/esm/Plus';
import CertifyIcon from '@mui/icons-material/WorkspacePremiumOutlined';
import PWMCopyIcon from '@mui/icons-material/FileCopyTwoTone'
import DIRDownloadIcon from './DownloadDIRPDF';
import CSLBDownloadIcon from './DownloadCSLBPDF';
import {SvgIcon} from '@mui/material';

const PWMPlusIcon = ()=>(<SvgIcon><PwmPlusIcon /></SvgIcon>)
export {
  PWMSOPIcon, PWMDownloadIcon, PWMLogIcon, PWMAltLogIcon, PWMXIcon, PWMArrowDownIcon, PWMHelpIcon,
  PWMArrowUpIcon, PWMArrowLeftIcon, PWMCopyIcon, PWMArrowRightIcon, PWMEditIcon, PWMRefreshIcon, PWMPdfIcon,
  PWMCheckedIcon, PWMUncheckedIcon, PWMPlusIcon, PWMWarningIcon, PWMMenuIcon, PWMVerifiedIcon, CertifyIcon,
  DIRDownloadIcon, CSLBDownloadIcon, PWMViewIcon, PWMFolderIcon, PWMDeleteIcon, PWMFileIcon, PWMListIcon, PWMSearchIcon,
  PWMInActiveIcon
}